<template>
    <div class="t-page_courses t-work-area">
        <transition name="fade">
            <div v-if="!fullUserInfo">
                <h1>{{pageTextInfo.otherTitle}}</h1>

                <div class="t-work-area__row">
                    <div class="t-work-area__column_big">
                        <div class="t-work-area__cell t-curseCreate">
                            <h2>
                                {{pageTextInfo.otherTitle_1}}
                            </h2>
                            <p class="t-profile__description">
                                {{pageTextInfo.otherDescription}}
                            </p>
                            <h2>

                                {{pageTextInfo.otherTitle_2}}
                            </h2>

                            <div class="t-inputBox">
                                <div class="t-input "
                                    :class="[item.class, {_error: item.error, 't-input_30': item.type !== 'textarea'}]"
                                    v-for="(item, index) in form_info"
                                    :key="index">
                                    <label>
                                        {{ item.title }}
                                        <span v-if="item.required && (item.value == '' || item.value == [] || item.value == null ) "
                                                class="t-must">
                                            {{pageTextInfo.must}}
                                        </span>
                                    </label>

                                    <textarea-autosize v-if="item.type === 'textarea'" v-model="item.value"
                                                    :min-height="80"></textarea-autosize>

                                    <input v-if="item.type === 'text'" v-model="item.value">

                                    <date-picker v-if="item.type === 'date'"
                                                v-model="item.value"
                                                :first-day-of-week="1"
                                                lang="ru"
                                                format="DD.MM.YYYY"
                                                :clearable="false" width="100%"></date-picker>

                                    <v-select v-if="item.type === 'select' && item.name === 'location'"
                                            v-model="item.value"
                                            :options="item.options"
                                            :searchable="item.searchable"
                                            :filterable="false"
                                            @search="yandexSearch(index, $event)"
                                            @input="yandexSearch(index, $event)">
                                        <template #no-options="{ search, searching, loading }">
                                            {{ pageTextInfo.locationNoOptions }}
                                        </template>
                                    </v-select>

                                    <v-select v-if="item.type === 'select' && item.name !== 'location'"
                                            v-model="item.value"
                                            :options="item.options"
                                            :searchable="true"
                                            :filterable="true"></v-select>

                                    <cmp-multi-select v-if="item.type === 'select_multi'"
                                                    :value="item.value"
                                                    :options="item.options"
                                                    :name="item.name"
                                                    @updateSelect="updateSelect(index, $event)"
                                    ></cmp-multi-select>

                                    <cmp-topics-select v-if="item.type === 'topics_select'"
                                                    :value="item.value"
                                                    :options="item.options"
                                                    :name="item.name"
                                                    v-model="item.value"
                                                    class="_right"
                                    ></cmp-topics-select>
                                </div>
                            </div>
                            <h2>
                                {{ pageTextInfo.imageTitle}} 
                                <span v-if="user.img == '' && !editImage" class="t-must">
                                    {{ pageTextInfo.imageMust}} 
                                </span>
                            </h2>
                            <div class="t-avatar">
                                <span class="t-avatar__info">{{ pageTextInfo.infoImg }}</span>
                                <div class="t-avatar_wrapper">
                                    <img v-if="user.img !== '' && !editImage" class="t-avatar__img" :src="user.img" >
                                    <img v-else-if="!editImage" class="t-avatar__img" src="/img/default_img.png">
                                    <div v-else class="t-avatar__img t-avatar__img-edit" > 
                                        <v-image-input
                                            v-model="imageData"
                                            image-format="jpeg"
                                            :hideActions="true" 
                                            :fullHeight="true"
                                            :fullWidth="true"
                                            overlayPadding="10px"
                                        />
                                    </div>
                                    <label v-if="!editImage" class="t-btn t-btn_full t-btn_file">
                                        <input type="file" @change="EditImage($event.target.files)"><span>{{ pageTextInfo.uploadImg }}</span>
                                    </label>

                                    <!-- <button v-if="editImage" class="t-btn t-btn_full t-btn_file" @click.stop.prevent="SaveImage()" type="button"
                                            ><span>{{ pageTextInfo.saveImg }}</span></button> -->
                                    <!-- <label class="t-btn t-btn_full t-btn_file">
                                        <input type="file" @change="LoadFile($event.target.files)"><span>{{ pageTextInfo.uploadImg }}</span>
                                    </label> -->
                                    <!-- <button v-if="editImage" class="t-btn t-btn_full t-btn_file" @click="SaveImg" type="button" >
                                        <span>{{ pageTextInfo.saveImg }}</span>
                                    </button> -->
                                    <!-- <button class="t-btn t-btn_full t-btn_white" @click.stop.prevent="DelAvatar()"
                                            v-if="user.img !== ''"><span>{{ pageTextInfo.deleteImg }}</span></button> -->
                                </div>
                                
                            </div>
                            <h2>{{ pageTextInfo.contacts }}</h2>
                            <div class="t-inputBox t-inputBox_column t-inputBox_column-start">
                                <div  v-for="(contact, index) in form_contacts" :key="'contact'+index"
                                        class="t-profile__contactsInput" 
                                        :class="{'_must': contact.must}">
                                    <div class="t-input t-input_320" :class="{_error: contact.error, '_success': (contact.value != '') }">
                                        <label>
                                            {{ contact.title }} 
                                            <span v-if="contact.must && contact.value==''" class="t-must">{{pageTextInfo.must}}</span>
                                        </label>
                                        <input v-model="contact.value" @input="InputContact(contact)" @focus="FocusContact(contact)">
                                    </div>
                                    <button class="t-input__delete" @click.stop.prevent="DelContact(index)">
                                        <svg width="15" height="18" viewBox="0 0 15 18" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M8.99831 1C8.99831 0.447266 8.55105 0 7.99831 0C7.62136 0 7.29324 0.207031 7.12331 0.513672C7.04324 0.658203 6.99831 0.824219 6.99831 1V2H2.99831C2.44558 2 1.99831 2.44727 1.99831 3C1.99831 3.55273 2.44558 4 2.99831 4H7.99831H12.9983C13.551 4 13.9983 3.55273 13.9983 3C13.9983 2.44727 13.551 2 12.9983 2H8.99831V1ZM1.99831 5C1.70144 5 1.42019 5.13086 1.23074 5.35938C1.04128 5.58594 0.961205 5.88672 1.01394 6.17969L1.74245 10.1797L2.46902 14.1797L3.01394 17.1797C3.10183 17.6543 3.51589 18 3.99831 18H11.9983C12.4807 18 12.8948 17.6543 12.9827 17.1797L14.2542 10.1797L14.9827 6.17969C15.012 6.01367 15.0003 5.8457 14.9495 5.68945C14.9104 5.57031 14.8479 5.45703 14.7659 5.35938C14.5764 5.13086 14.2952 5 13.9983 5H1.99831ZM3.56081 9L3.19558 7H12.801L12.4358 9H3.56081ZM4.28738 13L3.9241 11H12.0725L11.7093 13H4.28738ZM4.8323 16L4.65066 15H11.346L11.1643 16H4.8323Z"
                                                fill="#52A8F2"/>
                                        </svg>
                                    </button>
                                    <div class="t-profile__contactsCheckbox">
                                        <div>
                                            <svg width="12" height="14" viewBox="0 0 12 14" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                    d="M2 2V11.22L3.74603 9.55893C4.34081 8.9931 5.12899 8.63474 6 8.63474C6.871 8.63474 7.65919 8.9931 8.25397 9.55893L10 11.22V2H2ZM9.9662 12.2101C9.96605 12.21 9.96707 12.2079 9.96972 12.2042C9.96767 12.2083 9.96635 12.2102 9.9662 12.2101ZM2.0338 12.2101C2.03365 12.2102 2.03232 12.2083 2.03028 12.2042C2.03293 12.2079 2.03395 12.21 2.0338 12.2101ZM10.5 0C11.3284 0 12 0.888889 12 1.98539V12.0111C12 13.6286 10.6169 14.5673 9.62455 13.6233L6.87545 11.008C6.35237 10.5103 5.64763 10.5103 5.12455 11.008L2.37545 13.6233C1.3831 14.5673 0 13.6286 0 12.0111V1.98539C0 0.888889 0.671573 0 1.5 0H10.5Z"
                                                    fill="#B8D7F5"/>
                                            </svg>
                                            <input type="checkbox" :id="'newContactMain_' + index" class="t-checkbox"
                                                v-model="contact.main" @change="SetMainContact(index)">
                                            <label :for="'newContactMain_' + index">
                                                {{ pageTextInfo.main }}
                                            </label>
                                        </div>
                                        <div>
                                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                        d="M0.379518 12C0.283133 12 0.192771 11.9657 0.108434 11.8971C0.0361446 11.8286 0 11.7429 0 11.64L0.0361446 11.4857L4.39157 0.428572C4.4759 0.142857 4.68675 0 5.0241 0H6.99398C7.30723 0 7.51807 0.142857 7.62651 0.428572L11.9819 11.4857C11.994 11.52 12 11.5714 12 11.64C12 11.7429 11.9639 11.8286 11.8916 11.8971C11.8193 11.9657 11.7349 12 11.6386 12H10.0663C9.90964 12 9.78916 11.9657 9.70482 11.8971C9.62048 11.8286 9.56627 11.7543 9.54217 11.6743L8.69277 9.58286H3.3253L2.4759 11.6743C2.37952 11.8914 2.20482 12 1.95181 12H0.379518ZM8.06024 7.61143L6 2.31429L3.95783 7.61143H8.06024Z"
                                                        fill="#B8D7F5"/>
                                            </svg>
                                            <input type="checkbox" :id="'newContactAdmin_' + index" class="t-checkbox"
                                                v-model="contact.admin">
                                            <label :for="'newContactAdmin_' + index">
                                                {{ pageTextInfo.admin }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="t-input t-input_320">
                                    <label>{{ pageTextInfo.newContacts }}</label>
                                    <v-select :placeholder="pageTextInfo.addContacts"
                                            :options="contactsType"
                                            :searchable="false"
                                            :filterable="false"
                                            @input="AddContacts($event)"></v-select>
                                </div>
                            </div>
                            <button class="t-btn" :disabled="!canSave || !canSaveContacts || !canSaveImg" @click.stop.prevent="SaveInfo(true)"><span>{{ pageTextInfo.saveBtn }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <h1>{{ pageText.title }}</h1>
                <div class="t-work-area__row">
                    <div class="t-work-area__column_big t-work-area__column_big_create" :ref="'big-collumn'" >
                        <div v-if=" !mobileState || formBlocks[currentFormMobileIndex] == 'name'" :ref="'name'" class="t-work-area__cell t-curseCreate" :class="{'t-curseCreate__item': showHints && !mobileState, 't-curseCreate__item_active': true }" >
                            <!-- :class="{'t-curseCreate' : progress. }" -->
                            <h2>{{ pageText.titleLevelTwoOne }}</h2>
                            <div class="t-input t-input_checkbox">
                                <div v-for="(radio, index_radio) in type.items" :key="'courses_type_' + index_radio">
                                    <input type="radio" v-model="type.value" :value="radio.value" :id="'type_' + index_radio"
                                            class="t-radio" @change="ChangeType">
                                    <label :for="'type_' + index_radio">{{ radio.title }}</label>
                                </div>
                            </div>
                            <div class="t-input"
                                    :class="[form.name.class, {'_error': (!mobileState&&form.name.error)||(mobileState && formBlockMibleError == 'name' && form.name.keyInFormCheck == formBlockMibleError && !checkForm[formBlockMibleError].items[form.name.indexInFormCheck].check)}]">
                                <label>{{ form.name.label }}</label>
                                <input v-model="form.name.value" :placeholder="form.name.placeholder"
                                    @input="ClearError('name'), ChangeFormBlock('name')">
                                <div v-if="form.name.description" class="t-input__description">
                                    <b class="t-input__description-tilte">{{form.name.description.title}}</b>
                                    <span class="t-input__description-text">{{form.name.description.text}}</span>
                                </div>
                            </div>

                        </div>
                        <div v-if=" !mobileState || formBlocks[currentFormMobileIndex] == 'description'" :ref="'description'" class="t-work-area__cell t-curseCreate" :class="{'t-curseCreate__item': showHints && !mobileState, 't-curseCreate__item_active': (currentForm == 'description' || changedForm.includes('description') ) }">
                            <h2>{{ pageText.titleLevelTwoTwo }}</h2>
                            <div class="t-inputBox">
                                <div class="t-input" v-for="(item, key) in form" :key="key"
                                        :class="[item.class, {'_error': (!mobileState && item.error)||(mobileState && formBlockMibleError == 'description' && item.keyInFormCheck == formBlockMibleError && !checkForm[formBlockMibleError].items[item.indexInFormCheck].check)}] ">
                                    <label v-if=" key!= 'name'">{{ item.label }}</label>

                                    <input v-model="item.value" v-if="item.type === 'text' && key != 'name'" :placeholder="item.placeholder"
                                            @input="ClearError(key), ChangeFormBlock('description')">

                                    <cmp-topics-select v-if="item.type === 'topics_select'"
                                                    :value="item.value"
                                                    :options="item.options"
                                                    :name="item.name"
                                                    :placeholder="item.placeholder"
                                                    v-model="item.value"
                                    ></cmp-topics-select>

                                    <textarea-autosize v-if="item.type === 'textarea'" :placeholder="item.placeholder"
                                                    v-model="item.value" :min-height="120"
                                                    @input="ClearError(key)" @input.native="ChangeFormBlock('description')"></textarea-autosize>

                                    <v-select v-if="item.type === 'select'"
                                            v-model="item.value"
                                            :options="item.options"
                                            :placeholder="item.placeholder"
                                            :searchable="false"
                                            :filterable="false"
                                            @input="ClearError(key), ChangeFormBlock('description')"></v-select>

                                    <div v-if="item.description && key!= 'name'" class="t-input__description">
                                        <b class="t-input__description-tilte">{{item.description.title}}</b>
                                        <span class="t-input__description-text">{{item.description.text}}</span>
                                    </div>
                                </div>

                                <div class="t-input t-input_30 t-input_tablet_full" v-if="type.value !== 3">
                                    <label>{{ lessons[0].duration.label }}</label>
                                    <v-select v-model="lessons[0].duration.value"
                                            :options="lessons[0].duration.options"
                                            :placeholder="lessons[0].duration.placeholder"
                                            :searchable="false"
                                            :filterable="false"></v-select>
                                </div>
                            </div>
                        </div>
                        <template v-if=" !mobileState || formBlocks[currentFormMobileIndex] == 'lessons'">
                            <template v-if="type.value === 3">
                                <div :ref="'lessons'" class="t-work-area__cell t-curseCreate" :class="{'t-curseCreate__item': showHints && !mobileState, 't-curseCreate__item_active':  (currentForm == 'lessons' || changedForm.includes('lessons') ) }" >
                                        <h2>{{ pageText.lessonsTitle }}</h2>
                                        <div class="t-lesson" v-for="(lesson, index) in lessons" :key="'lesson_' + index">
                                            <h2>{{ index + 1 }}
                                                <span class="t-lesson__del" @click.stop.prevent="DelLessonCourse(index)">
                                                    <svg width="15" height="18" viewBox="0 0 15 18" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                                                d="M8.99831 1C8.99831 0.447266 8.55105 0 7.99831 0C7.62136 0 7.29324 0.207031 7.12331 0.513672C7.04324 0.658203 6.99831 0.824219 6.99831 1V2H2.99831C2.44558 2 1.99831 2.44727 1.99831 3C1.99831 3.55273 2.44558 4 2.99831 4H7.99831H12.9983C13.551 4 13.9983 3.55273 13.9983 3C13.9983 2.44727 13.551 2 12.9983 2H8.99831V1ZM1.99831 5C1.70144 5 1.42019 5.13086 1.23074 5.35938C1.04128 5.58594 0.961205 5.88672 1.01394 6.17969L1.74245 10.1797L2.46902 14.1797L3.01394 17.1797C3.10183 17.6543 3.51589 18 3.99831 18H11.9983C12.4807 18 12.8948 17.6543 12.9827 17.1797L14.2542 10.1797L14.9827 6.17969C15.012 6.01367 15.0003 5.8457 14.9495 5.68945C14.9104 5.57031 14.8479 5.45703 14.7659 5.35938C14.5764 5.13086 14.2952 5 13.9983 5H1.99831ZM3.56081 9L3.19558 7H12.801L12.4358 9H3.56081ZM4.28738 13L3.9241 11H12.0725L11.7093 13H4.28738ZM4.8323 16L4.65066 15H11.346L11.1643 16H4.8323Z"
                                                                fill="#52A8F2"/>
                                                    </svg>
                                                </span>
                                            </h2>
                                            <div class="t-inputBox t-inputBox_wrap">
                                                <div v-for="(item, index_item) in lesson" v-if="item.value != undefined"  :key="'lesson_input_' + index_item"
                                                        class="t-input" :class="[item.class, {'_error': (!mobileState && item.error)}]" >
                                                    <label>{{ item.label }}</label>

                                                    <input v-if="item.type === 'text'" v-model="item.value" :placeholder="item.placeholder" @input="ClearErrorLesson(index, index_item), ChangeFormBlock('lessons')">

                                                    <textarea-autosize v-if="item.type === 'textarea'" :placeholder="item.placeholder"
                                                            v-model="item.value" :min-height="80" @input.native="ClearErrorLesson(index, index_item), ChangeFormBlock('lessons')"></textarea-autosize>

                                                    <v-select v-if="item.type === 'select'"
                                                            v-model="item.value"
                                                            :options="item.options"
                                                            :placeholder="item.placeholder"
                                                            :searchable="false"
                                                            :filterable="false"></v-select>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="t-input">
                                            <button class="t-btn t-btn_white" @click.prevent="AddLesson()"><span>{{ pageText.addLesson
                                                }}</span></button>
                                        </div>
                                </div>
                            </template>
                        </template>


                        <div v-if=" !mobileState || formBlocks[currentFormMobileIndex] == 'calendar'" :ref="'calendar'" class="t-work-area__cell t-curseCreate" :class="{'t-curseCreate__item': showHints && !mobileState, 't-curseCreate__item_active':  ( currentForm == 'calendar' || changedForm.includes('calendar') ) }">
                            <h2>{{ pageText.calendar }}</h2>
                            <cmp-calendar :lesson_type="type.value" :lessons="lessons" :lesson_index="lesson_index" @click.native="ChangeFormBlock('calendar')"></cmp-calendar>
                            <div class="t-input_buttons t-curseCreate__buttons">
                                <button class="t-btn"  :disabled="posting" @click.prevent="Create('mod')"><span>{{ pageText.publishedBtn }}</span>
                                </button>
                                <button class="t-btn t-btn_white"  :disabled="posting"  @click.prevent="Create('save')"><span>{{ pageText.ineditedBtn
                                    }}</span></button>
                            </div>
                            <div class="t-curseCreate__error" v-if="lessons_error">
                                {{ pageText.error }}
                            </div>
                        </div>

                        <div v-if="mobileState" >
                            <div class="t-input_buttons t-curseCreate__buttons t-curseCreate__buttons_margin">
                                <button v-show="currentFormMobileIndex != formBlocks.length -1 " class="t-btn"  @click.prevent="setCurrentFormMobile(currentFormMobileIndex + 1)"><span>{{ pageText.nextBtn }}</span>
                                </button>
                                <button v-show="currentFormMobileIndex != 0" class="t-btn t-btn_white"  @click.prevent="setCurrentFormMobile(currentFormMobileIndex - 1)"><span>{{ pageText.prevBtn }}</span></button>
                            </div>
                        </div>
                    </div>
                    <div class="t-work-area__column_small t-work-area__column_small_create">
                        <div class="t-curseCreateHint__wrapper" :style="hintsBlockStyleAll" >
                            <div class="t-work-area__cell t-curseCreateHint" ref="hint">
                                <div class="t-progressBar">
                                    <div class="t-progressBar__progress" :style="{width: progressPercent+'%'}">
                                        <div class="t-progressBar__percent">
                                            {{progressPercent}}%
                                        </div>
                                    </div>
                                </div>
                                <transition name="fade" mode="out-in">
                                    <template v-if="showHints && currentFormTimeOut !='' && checkForm[currentFormTimeOut]"> 
                                        <div>
                                            <h3 class="t-curseCreateHint__title">
                                                {{checkForm[currentFormTimeOut].title}}
                                            </h3>
                                            <p class="t-curseCreateHint__text">
                                                {{checkForm[currentFormTimeOut].text}}
                                            </p>
                                            <ul class="t-curseCreateHint__errorList">
                                                <li v-for="(item, index) in checkForm[currentFormTimeOut].items" class="t-curseCreateHint__errorItem" :key="index">
                                                    <transition name="fade" mode="out-in">
                                                        <svg v-if="item.check" class="t-curseCreateHint__errorItem-icon" width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6097 0.357052C13.1226 0.840149 13.1311 1.63156 12.6287 2.12472L4.98786 9.62472C4.73632 9.87162 4.38969 10.0074 4.03033 9.99969C3.67097 9.99202 3.33095 9.84162 3.09106 9.58422L0.331876 6.62369C-0.147281 6.10957 -0.102265 5.3193 0.432421 4.85857C0.967107 4.39785 1.78899 4.44113 2.26815 4.95525L4.1014 6.92229L10.7713 0.375276C11.2738 -0.117886 12.0968 -0.126045 12.6097 0.357052Z" fill="#1AE1A6"/>
                                                        </svg>
                                                        <svg v-else class="t-curseCreateHint__errorItem-icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M8.15549 6.10264L11.6079 2.65019C12.1307 2.12745 12.1307 1.27992 11.6079 0.757181L11.2428 0.392054C10.7201 -0.130685 9.87255 -0.130685 9.34982 0.392054L5.89736 3.84451L2.56221 0.509359C2.03947 -0.0133792 1.19194 -0.0133793 0.669203 0.509359L0.509358 0.669204C-0.0133802 1.19194 -0.0133802 2.03947 0.509358 2.56221L3.84451 5.89736L0.392054 9.34982C-0.130685 9.87255 -0.130685 10.7201 0.392054 11.2428L0.757181 11.6079C1.27992 12.1307 2.12745 12.1307 2.65018 11.6079L6.10264 8.15549L9.46712 11.52C9.98986 12.0427 10.8374 12.0427 11.3601 11.52L11.52 11.3601C12.0427 10.8374 12.0427 9.98986 11.52 9.46712L8.15549 6.10264Z" fill="#F24949"/>
                                                        </svg>
                                                    </transition>

                                                    {{item.text}}
                                                </li>
                                            </ul>
                                        </div>
                                    </template>
                                </transition>
                                <button class="t-btn t-btn_full  t-btn_white t-curseCreateHint__btn "  @click.prevent="ChangeHints()">
                                    <span>
                                        <template v-if="showHints">
                                            {{ pageText.closeHintsBtn}}
                                        </template>
                                        <template v-else>
                                            {{ pageText.openHintsBtn}}
                                        </template>
                                    </span>
                                </button>
                                
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </transition>
    </div>
</template>
<script>
    let localeText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/courseCreate.json' : 'staticText',
        main: {
            title: "Новый",
            titleLevelTwoOne: "Название и тип урока",
            titleLevelTwoTwo: "Описание вашего занятия",
            lessonsTitle: "Уроки курса",
            addLesson: "Добавить ещё урок",
            calendar: "Расписание",
            publishedBtn: "Опубликовать",
            ineditedBtn: "Сохранить без публикации",
            error: "Необходимо расставить занятия по дням",
            type: ["Урок", "Консультация", "Курс"],
            formName: "Название",
            formKnowledge: "Области знаний",
            formTopics: "Темы",
            formVideo: "Видео",
            formVideoPlaceholder: "Youtube или Vimeo",
            formDescription: "Описание",
            formPrice: "Цена",
            formPricePlaceholder: "Например 700",
            formStudents: "Слушателей максимум",
            formStudentsPlaceholder: "от 1 до 10",
            formDuration: "Продолжительность",
            formNameLesson: "Название",
            formNameLessonPlaceholder: "Введите название урока",
            formDescriptionLesson: "Описание урока",
            formDescriptionLessonPlaceholder: "Короткое описание урока",
            formDescriptions: {
                name: {
                    title: "Хороший пример:",
                    text: "Дуализм героя в концепции Гегеля | Физико-химические свойства углерода (III ступень)"
                },
                video:  {
                    title: "Совет:",
                    text: "добавьте ссылку на видеопрезентацию урока."
                },
                text:  {
                    title: "Опишите курс подробно:",
                    text: "пользователи в 92% случаев выбирают занятия с хорошим подробным описанием."
                },
                price:  {
                    title: "Совет:",
                    text: "выставляйте цену за занятие, ориентируясь на рынок: слишком дорогие занятия пользоваели проигнорируют, а слишком дешёвые могут вызвать подозрения, поставив под сомнение квалификацию преподавателя."
                },
            },
            formHints: {
                name: {
                    title: "Назовите урок и определите его тип",
                    text: "Название занятия должно быть таким, чтобы привлечь внимание учеников и отразить суть тех знаний, которые будут отражены на уроке.",
                    items:[
                        {
                            text: "Название урока"
                        }
                    ]
                },
                description: {
                    title: "Сделайте подробное описание",
                    text: "Выберите одну из тем, чтобы ваше занятие было проще найти. Опишите урок так, чтобы ученику было легко сориенитроваться, какую пользу ему может принести обучение конкретно у вас.",
                    items:[
                        {
                            text: "Темы"
                        },
                        {
                            text: "Описание"
                        },
                        {
                            text: "Цена"
                        },
                        {
                            text: "Слушателей максимум"
                        }
                    ]
                },
                lessons: {
                    title: "Опишите каждый урок из курса",
                    text: "Чтобы хорошо была видна структура курса, назовите и подробно распишите ваши уроки ",
                    items:[
                        {
                            text: "Названия уроков"
                        },
                        {
                            text: "Описания уроков"
                        }
                    ]
                },
                calendar: {
                    title: "Проставьте уроки в календаре",
                    text: "Нажмите на ячейку дня, когда вы можете провести урок. Выберите время и длительность занятия. Рекомендуем указать все дни и время, когда вы можете провести уроки сразу. Сделайте план на 2 или 4 недели вперед.",
                    items:[
                        {
                            text: "Даты занятия проставлены"
                        }
                    ]
                },
            },
            nextBtn: 'Продолжить',
            prevBtn: 'Назад',
            openHintsBtn: "Нужна помощь",
            closeHintsBtn: "Заполню всю форму самостоятельно",
            msgCanSaveCourse1: "Добавьте все занятия. Добавлено только ",
            msgCanSaveCourse2: " из ",
            msgAllLessonsAdd: "Все уроки по курсу добавлены",
            msgPressSaveBtn: "Чтобы все изменения вступили в силу, нажмите «Сохранить изменения»",
            msgLimitEnd: "Лимит на добавление дат исчерпан",
            msgCreate: "Урок создан",
        }
    };


    import {store} from '../../store'

    import Calendar from '../../vue_components/Calendar/Calendar.vue'

    import user from '../../store/modules/user';

    import {mapActions, mapGetters} from 'vuex';


    import EdirMyInfo from '../../vue_mixins/EditMyInfo';

    export default {

        mixins: [EdirMyInfo],
        components: {
            'cmp-calendar': Calendar,
        },
        computed: {
            ...mapGetters(['mobileState']),
            ...mapGetters('calendar', ['date_active', 'calendarTypeValue', 'day_week_header']),
            ...mapGetters('profile', ['settings']),
            fullUserInfo(){

                if (this.user.name == '' ||  this.user.name == null){
                    return false
                }
                if (this.user.last_name == '' ||  this.user.last_name == null){
                    return false
                }
                // отчество не обязательное
                // if (this.user.patronymic == '' ||  this.user.patronymic == null){
                //     return false
                // }
                // if (this.user.birth_day == '' ||  this.user.birth_day == null){
                //     return false
                // }
                // if (this.user.location == '' ||  this.user.location == null){
                //     return false
                // }
                if (this.user.time_zone == '' ||  this.user.time_zone == null){
                    return false
                }
                if (this.user.language == '' ||  this.user.language == null){
                    return false
                }
                if (this.user.topics == '' ||  this.user.topics == null){
                    return false
                }
                if (this.user.about == '' ||  this.user.about == null){
                    return false
                }
                if (this.user.education == '' ||  this.user.education == null){
                    return false
                }
                if (this.user.experience == '' ||  this.user.experience == null){
                    return false
                }
                if (this.user.img == '' ||  this.user.img == null){
                    return false
                }
                let hasEmail = false;
                if (this.user.contacts) {
                    if (this.user.contacts.length > 0 ){
                        this.user.contacts.some(item => {
                            if (item.type == 'email' && item.value != ''){
                                hasEmail = true;
                                return true;
                            }
                            return false;
                        })
                    } 
                }

                if (!hasEmail){
                    return false;
                }
                setTimeout(() => {
                    window.scrollTo(0, 0);
                }, 300);
                return true
            },
            checkForm(){
                // это вычисляемое свойство следит за полнотой заполнения формы создания урока
                let dependence = {};
                let final = {};
                if (this.load){
                    // при создании кмпонента появляются данные, переводы с сервера и уже только при их наличии можно делать проверку
                    let lessonNames = true;
                    let lessonText = true;
                    let lessonDate = true;
                    let min = 0;
                    this.lessons.forEach((item)=>{
                        if (lessonNames && item.lessonName.value == ''){
                            lessonNames = false;
                        }
                        if (lessonText && item.text.value == ''){
                            lessonText = false;
                        }
                        if (lessonDate ){
                            if (item.date_time.length == 0){
                                lessonDate = false
                            } else {
                                min = item.date_time.length>min?item.date_time.length: min;
                                if (item.date_time.length < min ) {
                                    lessonDate = false
                                }
                            }
                        }
                    })
                    // dependence - объект отвечающий за зависимости денных и результатов их проверки
                    dependence = {
                        name: {
                            items: [
                                {
                                    check: this.form.name.value != '',
                                    changed: this.form.name.changed
                                }
                            ]
                        },
                        description: {
                            items: [
                                {
                                    check: this.form.topics.value.length > 0,
                                    changed: this.form.topics.changed,
                                },
                                {
                                    check: this.form.text.value != '',
                                    changed: this.form.text.changed
                                },
                                {
                                    check: this.form.price.value != '',
                                    changed: this.form.price.changed
                                },
                                {
                                    check: this.form.students.value != '',
                                    changed: this.form.students.changed
                                }
                            ]
                        },
                        lessons: {
                            items: [
                                {
                                    check: lessonNames,
                                    changed: true
                                },
                                {
                                    check: lessonText,
                                    changed: true
                                }
                            ]
                        },
                        calendar: {
                            items: [
                                {
                                    check: lessonDate,
                                    changed: true
                                }
                            ]
                        },
                    }
                    final = this.pageText.formHints

                    for (const key in dependence) {
                        if (dependence.hasOwnProperty(key)) {
                            for (let i = 0; i < dependence[key].items.length; i++) {
                                final[key].items[i].check = dependence[key].items[i].check;
                            }
                        }
                    }

                    // this.pageText.formHints - объект содержащий текст для вывода сообщений об ошибках и советы по заполнению для правой панели

                }
                return final;
            },  
            progressPercent(){
                let summ = 0;
                let all = 0;
                for (let stepKey in this.checkForm) {
                    if (!(this.type.value != 3 && stepKey === 'lessons')) {
                            this.checkForm[stepKey].items.forEach((item)=>{
                            all++;
                            if(item.check){
                                summ++;
                            }
                        })
                    } 
                }
                return (all === 0)? 0: parseInt(summ*100/all);
            },
            checkedFormBlocks(){
                let checkedFormBlocks = [];
                for (let stepKey in this.checkForm) {
                    if (!(this.type.value != 3 && stepKey === 'lessons') ) {
                        checkedFormBlocks.push(stepKey);
                        let itemsCheck = true;
                        for (let index = 0; index < this.checkForm[stepKey].items.length; index++) {
                            const element = this.checkForm[stepKey].items[index];
                            if(!element.check){
                                itemsCheck = false;
                                break;
                            }
                        }
                        if (itemsCheck){
                        } else {
                            break;
                        }
                    } 
                }
                return checkedFormBlocks;
            },
            currentForm(){
                let checkedFormBlocks = '';
                
                if (this.mobileState) {
                    checkedFormBlocks =  this.formBlocks[this.currentFormMobileIndex];
                } else {
                    for (let stepKey in this.checkForm) {
                        if (!(this.type.value != 3 && stepKey === 'lessons') ) {
                            checkedFormBlocks = stepKey;
                            let itemsCheck = true;
                            for (let index = 0; index < this.checkForm[stepKey].items.length; index++) {
                                const element = this.checkForm[stepKey].items[index];
                                if(!element.check){
                                    itemsCheck = false;
                                    break;
                                }
                            }
                            if (itemsCheck){
                            } else {
                                break;
                            }
                        } 
                    }
                }
                if (this.showHints){}

                return checkedFormBlocks;
            },
            formBlocks(){
                let formBlocks = [];
                // let formBlocks = ['name', 'description'];
                // if (this.type.value == 3){
                //     formBlocks.push('lessons');
                // }
                // formBlocks.push('calendar');
                for(let key in this.checkForm){
                    if (key == 'lessons'  ){
                        if (this.type.value == 3)
                            formBlocks.push(key)
                    } else {
                        formBlocks.push(key)
                    }
                }
                return formBlocks;
            }, 
            hintsBlockStyleAll(){
                if(this.showHints && this.hintsBlockStyle){
                    return this.hintsBlockStyle
                } else {
                    return {height: '100%', top: 0}
                }
            }

        },
        data() {
            return {
                load: false,
                showHints: false,
                hintsBlockStyle: {
                    height: '100%',
                    top: 0
                },
                pageText: {},
                formBlockMibleError: '',
                posting: false, // переменная показывает отправку на сервер данных, для отсекания дублированных запросов
                changedForm: [],
                currentFormIfTrigger: false,
                currentFormTimeOut: '',
                currentFormMobileIndex: 0,
                // currentFormMobile: 'name',
                // FormBlocks: ['name', ],
                maxDate: 60,
                lesson_index: 0,
                lessons_error: false,
                type: {
                    value: 1,
                    items: [
                        {
                            value: 1,
                            title: ''
                        },
                        {
                            value: 2,
                            title: ''
                        },
                        {
                            value: 3,
                            title: ''
                        }
                    ]
                },
                form: {
                    name: {
                        type: 'text',
                        label: '',
                        name: 'name',
                        full: true,
                        class: '',
                        error: false,
                        required: true,
                        value: '',
                        placeholder: '', 
                        keyInFormCheck: 'name',
                        indexInFormCheck: 0
                    },
                    topics: {
                        type: 'topics_select',
                        label: '',
                        name: 'topics',
                        full: false,
                        class: 't-input_70 t-input_tablet_full',
                        error: false,
                        required: false,
                        value: [],
                        options: store.getters['handbook/topics'],
                        placeholder: '', 
                        keyInFormCheck: 'description',
                        indexInFormCheck: 0
                    },
                    video: {
                        type: 'text',
                        label: '',
                        name: 'video',
                        full: false,
                        class: 't-input_30 t-input_tablet_full',
                        error: false,
                        required: false,
                        value: '',
                        placeholder: '', 
                        keyInFormCheck: '',
                        indexInFormCheck: -1
                    },
                    text: {
                        type: 'textarea',
                        label: '',
                        name: 'text',
                        full: true,
                        class: '',
                        error: false,
                        required: true,
                        value: '',
                        placeholder: '', 
                        keyInFormCheck: 'description',
                        indexInFormCheck: 1
                    },
                    price: {
                        type: 'text',
                        label: '',
                        name: 'price',
                        full: false,
                        class: 't-input_30 t-input_tablet_full',
                        error: false,
                        required: true,
                        value: '',
                        placeholder: '', 
                        keyInFormCheck: 'description',
                        indexInFormCheck: 2
                    },
                    students: {
                        type: 'select',
                        label: '',
                        name: 'students',
                        full: false,
                        class: 't-input_30 t-input_tablet_full',
                        error: false,
                        required: true,
                        value: '',
                        options: store.getters['handbook/listeners'],
                        placeholder: '', 
                        keyInFormCheck: 'description',
                        indexInFormCheck: 3
                    }
                },
                lessons: [
                    {
                        lessonName: {
                            type: 'text',
                            label: 'Название урока',
                            name: 'lessonName',
                            full: true,
                            class: 't-input_70 t-input_tablet_full',
                            error: false,
                            required: true,
                            value: '',
                            placeholder: ''
                        },
                        duration: {
                            type: 'select',
                            label: '',
                            name: 'duration',
                            full: false,
                            class: 't-input_30 t-input_tablet_full',
                            error: false,
                            required: true,
                            value: store.getters['handbook/duration'][0],
                            options: store.getters['handbook/duration'],
                            placeholder: ''
                        },
                        text: {
                            type: 'textarea',
                            label: '',
                            name: 'text',
                            full: true,
                            class: '',
                            error: false,
                            required: true,
                            value: '',
                            placeholder: ''
                        },
                        date_time: []
                    }
                ],
            }
        },
        methods: {
            ...mapActions(['UpdatePreloadState']),
            ...mapActions('msg', ['showMsg', 'showMsgObj']),
            ...mapActions('coursesList', ['LoadStreamsEntries', 'LoadStreamsMy']),
            ...mapActions('modal', ['modalDialogType_timezoneOpen']),
            AddDate(data) {
                if (this.maxDate > 0) {
                    this.lessons[this.lesson_index].date_time.push({
                        date: data,
                        update: true,
                        localStreamIndex: this.lessons[this.lesson_index].date_time.length + 1
                    });
                    this.lessons_error = false;

                    this.maxDate--;

                    if (this.type.value === 3) {
                        this.lesson_index++;
                        if (this.lesson_index >= this.lessons.length) {
                            this.lesson_index = 0;
                            this.showMsg(this.pageText.msgAllLessonsAdd)
                        }
                    }

                    this.showMsg(this.pageText.msgPressSaveBtn);
                } else {
                    this.showMsg(this.pageText.msgLimitEnd)
                }
            },
            UpdateDate(lesson_index, data) {
                for (let i = 0; i < data.length; i++) {
                    // this.lessons[lesson_index].date_time.splice(data[i].index, 1, data[i].date); 
                        this.lessons[lesson_index].date_time.splice(data[i].index, 1, {
                            date: data[i].date,
                            // update: true,
                            // id: this.lessons[lesson_index].date_time[data[i].index].id,

                            // streamId: this.lessons[lesson_index].date_time[data[i].index].streamId,
                            localStreamIndex: this.lessons[lesson_index].date_time[data[i].index].localStreamIndex,
                            // changed: true
                        });
                }
                this.showMsg(this.pageText.msgPressSaveBtn);
            },
            AddLesson() {
                this.lessons.push({
                    lessonName: {
                        type: 'text',
                        label: this.pageText.formNameLesson,
                        name: 'lessonName',
                        full: true,
                        class: 't-input_70 t-input_tablet_full',
                        error: false,
                        required: true,
                        value: '',
                        placeholder: this.pageText.formNameLessonPlaceholder
                    },
                    duration: {
                        type: 'select',
                        label: this.pageText.formDuration,
                        name: 'duration',
                        full: false,
                        class: 't-input_30 t-input_tablet_full',
                        error: false,
                        required: true,
                        value: store.getters['handbook/duration'][0],
                        options: store.getters['handbook/duration'],
                        placeholder: ''
                    },
                    text: {
                        type: 'textarea',
                        label: this.pageText.formDescriptionLesson,
                        name: 'text',
                        full: true,
                        class: '',
                        error: false,
                        required: true,
                        value: '',
                        placeholder: this.pageText.formDescriptionLessonPlaceholder,
                    },
                    date_time: []
                })
            },
            DelLesson(lesson_index, index) {
                this.lessons[lesson_index].date_time.splice(index, 1);
                this.maxDate++;
                this.showMsg(this.pageText.msgPressSaveBtn);
            },
            DelCourseStream(streamId) {
                this.lessons.forEach(item => {
                    item.date_time.splice(streamId, 1);
                    item.date_time.forEach( (item, index) => {
                        if (index >= streamId)
                            item.localStreamIndex--;
                    })
                    this.maxDate++;
                });
                // this.showMsg(this.pageText.msgPressSaveBtn);
            },
            DelLessonCourse(lesson_index) {
                if (this.lessons.length > 1){
                    this.maxDate += this.lessons[lesson_index].date_time.length;
                    this.lessons.splice(lesson_index, 1);
                }
            },
            ChangeType() {
                this.lessons = [{
                    lessonName: {
                        type: 'text',
                        label: this.pageText.formNameLesson,
                        name: 'lessonName',
                        full: true,
                        class: 't-input_70 t-input_tablet_full',
                        error: false,
                        required: true,
                        value: '',
                        placeholder: this.pageText.formNameLessonPlaceholder
                    },
                    duration: {
                        type: 'select',
                        label: this.pageText.formDuration,
                        name: 'duration',
                        full: false,
                        class: 't-input_30 t-input_tablet_full',
                        error: false,
                        required: true,
                        value: store.getters['handbook/duration'][0],
                        options: store.getters['handbook/duration'],
                        placeholder: ''
                    },
                    text: {
                        type: 'textarea',
                        label: this.pageText.formDescriptionLesson,
                        name: 'text',
                        full: true,
                        class: '',
                        error: false,
                        required: true,
                        value: '',
                        placeholder: this.pageText.formDescriptionLessonPlaceholder,
                    },
                    date_time: []
                }]
            },
            ClearError(key) {
                if (this.form[key].name === 'price') {
                    this.form[key].value = this.form[key].value.replace(/[^\d,.]/g, "");
                }
                this.formBlockMibleError = ''

                this.form[key].error = false;
            },
            ClearErrorLesson(index, key) {
                this.lessons[index][key].error = false;
            },
            ChangeFormBlock(key){
                if (!this.changedForm.includes(key))
                    this.changedForm.push(key)
            },
            Create(a) {
                if (!this.user.time_zone || !this.user.last_name || !this.user.name) {
                    this.modalDialogType_timezoneOpen();
                } else {
                    let valid = true;

                    for (let key in this.form) {
                        if (this.form[key].required) {
                            if (!this.form[key].value.length) {
                                valid = false;
                                this.form[key].error = true;
                            }
                        }
                    }

                    if (this.form.video.value !== '') {
                        if (this.form.video.value.indexOf('youtube') < 0 || this.form.video.value.indexOf('youtu.be') >= 0) {
                            if (this.form.video.value.indexOf('vimeo') < 0) {
                                this.form.video.error = true;
                            }
                        }
                    }

                    for (let i = 0; i < this.lessons.length; i++) {
                        if (this.lessons[i].date_time.length === 0) {
                            this.lessons_error = true;
                            valid = false;
                        }
                    }

                    if (this.type.value === 3){
                        let min = 0;
                        for (let i = 0; i < this.lessons.length; i++) {
                            if (this.lessons[i].lessonName.value == ''){
                                valid = false;
                                this.lessons[i].lessonName.error = true;
                            }
                            if (this.lessons[i].text.value == ''){
                                valid = false;
                                this.lessons[i].text.error = true;
                            }

                            min = this.lessons[i].date_time.length>min?this.lessons[i].date_time.length: min
                            if (this.lessons[i].date_time.length < min ) {
                                // this.lessons_error = true;
                                let str = this.pageText.msgCanSaveCourse1 + i + this.pageText.msgCanSaveCourse2 + this.lessons.length ;
                                this.showMsg(str)
                                valid = false;
                                break;
                            }
                        }
                    }

                    if (valid) {
                        let fd = new FormData();

                        fd.append('type', this.type.value);
                        fd.append('name', this.form.name.value);

                        for (let i = 0; i < this.form.topics.value.length; i++) {
                            if (typeof this.form.topics.value[i].value == "string") {
                                fd.append('topics_new[]', '{"parent_id":"'+ this.form.topics.value[i].value.split('-')[0] + '", "name":"'+ this.form.topics.value[i].label + '"}');
                            } else {
                                fd.append('topics[]', this.form.topics.value[i].value);
                            }
                        }

                        if (this.form.video.value !== '')
                            fd.append('video', this.form.video.value);

                        fd.append('text', this.form.text.value);
                        fd.append('price', this.form.price.value);
                        fd.append('students', this.form.students.value);

                        for (let i = 0; i < this.lessons.length; i++) {
                            let lesson = {
                                duration: this.lessons[i].duration.value.value,
                                items: []
                            };

                            if (this.type.value === 3) {
                                lesson['text'] = this.lessons[i].text.value
                            }
                            if (this.type.value === 3) {
                                lesson['lessonName'] = this.lessons[i].lessonName.value
                            }
                            for (let j = 0; j < this.lessons[i].date_time.length; j++) {
                                // lesson.items.push(this.lessons[i].date_time[j].date.toLocaleString("en", { hour12: false }));
                                // append = true;
                                let day = this.lessons[i].date_time[j].date.toLocaleString("en-US", { hour12: false }).split(', ')[0]
                                let time = this.lessons[i].date_time[j].date.toLocaleString("ru-RU", { hour12: false }).split(', ')[1]                                
                                // lesson.items.push(this.lessons[i].date_time[j].date.toLocaleString("en", { hour12: false }));
                                lesson.items.push(''+day+', '+time)
                            }
                            lesson = JSON.stringify(lesson);
                            fd.append('lessons[]', lesson);
                        }

                        this.posting = true;
                        if (a === 'mod') {
                            this.$http.post('create_lesson', fd)
                                .then(response => response.json())
                                .then(data => {
                                    if (data.success) {
                                        this.$router.push({name: 'my_courses'});
                                        this.showMsg(this.pageText.msgCreate);
                                    } else {
                                        this.showMsgObj(data.errors);
                                    }
                                    this.posting = false;
                                })
                                .catch(error => {

                                    this.showMsg('Упс, что-то пошло не так, попробуйте позже');
                                    this.posting = false;
                                });
                        }
                        if (a === 'save') {
                            this.$http.post('save_lesson', fd)
                                .then(response => response.json())
                                .then(data => {
                                    if (data.success) {
                                        this.$router.push({name: 'courses'});
                                        this.showMsg(this.pageText.msgCreate);
                                    } else {
                                        this.showMsgObj(data.errors);
                                    }
                                    this.posting = false;
                                })
                                .catch(error => {
                                    this.showMsg('Упс, что-то пошло не так, попробуйте позже');
                                    this.posting = false;
                                });
                        }

                    } else {
                        setTimeout(() => {
                            let el = document.querySelector('.t-input._error');

                            this.ScrollTo(el)
                        }, 200)
                    }
                }
            },
            ScrollTo(elem) {
                if (elem) {
                    let elem_coord = this.$root.getCoords(elem).top - 100;

                    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

                    if (elem_coord > scrollTop) {
                        scrollTop + 30 > elem_coord ? scrollTop = elem_coord : scrollTop += 30;
                        window.scrollTo(0, scrollTop);
                        setTimeout(() => {
                            let scrollHeight = Math.max(
                                document.body.scrollHeight, document.documentElement.scrollHeight,
                                document.body.offsetHeight, document.documentElement.offsetHeight,
                                document.body.clientHeight, document.documentElement.clientHeight
                            );
                            if (scrollTop < elem_coord && (scrollTop + window.innerHeight) < scrollHeight)
                                this.ScrollTo(elem)
                        }, 1)
                    } else {

                        scrollTop - 30 < elem_coord ? scrollTop = elem_coord : scrollTop -= 30;
                        window.scrollTo(0, scrollTop);
                        setTimeout(() => {
                            if (scrollTop > elem_coord)
                                this.ScrollTo(elem)
                        }, 1)
                    }
                }
            },
            Load(pageText) {
                let hasEmail = false;
                if (this.form_contacts.length > 0 ){
                    this.form_contacts.some(item => {
                        if (item.title == 'Email'){
                            hasEmail = true;
                            return true;
                        }
                        return false;
                    })
                }
                if (!hasEmail) {
                    
                    let obj = {};
                    this.contactsType.some(item => {
                        if (item.label == 'Email'){
                            obj = item 
                            obj.must = true
                            // console.log(item)
                            return true;
                        }
                        return false;
                    })
                    this.AddContacts(obj)
                }
                this.pageText = Object.assign({}, pageText);

                for (let i = 0; i < this.type.items.length; i++) {
                    if (!pageText.type[i]) {
                        continue;
                    }

                    this.type.items[i].title = pageText.type[i]
                }

                this.form.name.label = pageText.formName;
                this.form.topics.label = pageText.formTopics;
                this.form.video.label = pageText.formVideo;
                this.form.video.placeholder = pageText.formVideoPlaceholder;
                this.form.text.label = pageText.formDescription;
                this.form.price.label = pageText.formPrice;
                this.form.price.placeholder = pageText.formPricePlaceholder;
                this.form.students.label = pageText.formStudents;
                this.form.students.placeholder = pageText.formStudentsPlaceholder;

                // заполнение описания (и примеров) полей формы заполнения урока
                for (let key in pageText.formDescriptions) {
                    this.form[key].description = Object.assign({}, pageText.formDescriptions[key]);
                }

                this.lessons[0].duration.label = pageText.formDuration;
                this.lessons[0].text.label = pageText.formDescriptionLesson;
                this.lessons[0].text.placeholder = pageText.formDescriptionLessonPlaceholder;

                setTimeout(() => {
                    this.UpdatePreloadState(false);
                }, 500)
                // this.currentFormMobileIndex = 0; 
                this.load = true;
            },
            ChangeHints(){
                this.showHints = !this.showHints;
                localStorage.setItem('showHints', this.showHints );
            },
            setCurrentFormMobile(i){
                window.scrollTo(0, 0);

                this.formBlockMibleError = this.formBlocks[this.currentFormMobileIndex];

                if ( this.checkedFormBlocks.includes(this.formBlocks[i]) ) {
                    this.currentFormMobileIndex = i
                }
                // this.formBlocks[i]
            },
        },
        watch: {
            date_active() {
                let start, end;
                if (this.calendarTypeValue.value === 1) {
                    start = this.date_active.getFullYear() + '.' + (this.date_active.getMonth() + 1) + '.1';
                    end = this.date_active.getFullYear() + '.' + (this.date_active.getMonth() + 1) + '.' + this.date_active.daysInMonth();
                } else {
                    let m = this.day_week_header[0].value;
                    let s = this.day_week_header[this.day_week_header.length - 1].value;

                    start = m.getFullYear() + '.' + (m.getMonth() + 1) + '.' + m.getDate();
                    end = s.getFullYear() + '.' + (s.getMonth() + 1) + '.' + s.getDate();
                }

                this.LoadStreamsMy({start: start, end: end});
                this.LoadStreamsEntries({start: start, end: end});
            },
            currentForm(newValue){
                setTimeout(
                    ()=>{
                        this.currentFormTimeOut = newValue;
                    },
                700);
            },
            currentFormMobile(newValue){
                if (this.mobileState) {
                    this.currentFormTimeOut = this.formBlocks[newValue];
                } 
            },
            currentFormTimeOut(newValue){
                if(!this.mobileState){
                    this.hintsBlockStyle.height = ''+ this.$refs[newValue].offsetHeight + 'px';
                    this.hintsBlockStyle.top = ''+ ( this.$refs[newValue].offsetTop - this.$refs['big-collumn'].offsetTop ) + 'px';
                } 
            },
        },
        // created(){
        //     if(this.mobileState){
        //         console.log(this.$route)
        //         console.log(this.$route.query)
        //         if (!this.$route.query.block){
        //             this.$route.query.block = 'name'
        //         }
        //         console.log(this.$route.query)
        //     }
        // },
        mounted(){
            // показывать подсказки или нет
            let showHints = localStorage.getItem('showHints') ;
            if (!showHints){
                localStorage.setItem('showHints', true);
                this.showHints = true
            } else {
                this.showHints = showHints
            }
        },
        // beforeRouteUpdate(to, from, next) {
        //     // this.UpdatePreloadState(true);
        //     // to
        //     next();
        // },
        beforeRouteLeave(to, from, next) {
            this.UpdatePreloadState(true);
            next();
        },
        beforeRouteEnter(to, from, next) {
            let date = new Date();

            let start = date.getFullYear() + '.' + (date.getMonth() + 1) + '.1';
            let end = date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.daysInMonth();

            let count = 0;

            let pageText = {};

            store.dispatch('staticText/LoadPageText', localeText).then((data) => {
                pageText = data;
                count++;
                RunNext();
            });

            store.dispatch('calendar/LoadCalendarText').then(() => {
                count++;
                RunNext();
            });
            store.dispatch('handbook/LoadTopics').then(() => {
                count++;
                RunNext();
            });
            store.dispatch('handbook/LoadListeners').then(() => {
                count++;
                RunNext();
            });
            store.dispatch('handbook/LoadDuration').then(() => {
                count++;
                RunNext();
            });
            store.dispatch('handbook/LoadTimeZone').then(() => {
                count++;
                RunNext();
            });
            // store.dispatch('profile/LoadUserInfo').then(() => {
            //     count++;
            //     RunNext();
            // });
            store.dispatch('coursesList/LoadStreamsMy', {start: start, end: end}).then(() => {
                count++;
                RunNext();
            });
            store.dispatch('coursesList/LoadStreamsEntries', {start: start, end: end}).then(() => {
                count++;
                RunNext();
            });
            let RunNext = () => {
                if (count > 7)
                    next(vm => vm.Load(pageText))
            }
        }
    }
</script>

<style lang="sass">
    .t-progressBar
        position: relative
        bottom: 18px
        background: $grey_light
        border-radius: 16px
        &__progress
            position: relative
            width: 0%
            height: 6px
            background: $blue
            border-radius: 16px
            transition: width .3s
        &__percent
            position: absolute
            bottom: 8px
            width: 100%
            text-align: right
            padding: 0 24px
            color: $grey

    .t-curseCreateHint
        position: sticky
        top: 160px
        padding: 16px
        border: 1px solid $blue
        &__wrapper
            position: relative
            transition: top .5s linear
        &__title
            color: $blue
            font-weight: 500
            font-size: 16px
            line-height: 19px
            margin-bottom: 16px
        &__text
            margin-bottom: 16px
        &__errorList
            margin-bottom: 24px
        &__errorItem
            &-icon
                margin-right: 10px
        &__btn
            span
                // margin: 0 -8px
                // width: 100%
                white-space: nowrap
                margin: 10px 0
                width: 100%
                line-height: 1.4em
                display: inline-block
                @media(max-width: 769px)
                    white-space: unset

    .t-must
        display: inline-block
        margin-left: 4px
        font-weight: normal
        font-size: 14px
        line-height: 17px
        color: #F39049

    .t-curseCreate
        h2
            color: $blue
            margin: 0 0 24px
            font-size: 22px
        .t-calendar_small
            max-width: 320px
            margin: 0
        &__buttons
            margin-top: 23px
            flex-wrap: wrap
            .t-btn
                margin-top: 8px
            &_margin
                margin-right: 16px
                margin-left: 16px
        &__error
            font-size: 14px
            color: $red
        .t-lesson
            h2
                position: relative
                padding-right: 48px
                span
                    position: absolute
                    right: 0
                    top: 0
                    bottom: 0
                    width: 40px
                    height: 40px
                    display: flex
                    align-items: center
                    justify-content: center
                    margin: auto
                    cursor: pointer
            &:not(.t-history-lesson)
                // margin-top: 32px
                margin-bottom: 32px
        &__item
            opacity: .4
            pointer-events: none
            transition: opacity .3s
            &_active
                opacity: 1
                pointer-events: auto
    @media(min-width: 768px) and (max-width: 1024px)
        .t-curseCreate
            .t-multiSelect__dropdow
                width: auto 
    @media(max-width: 769px)
        .t-curseCreate
            .t-calendar_small
                margin: 0 auto
</style>



// WEBPACK FOOTER //
// src/vue_pages/Courses/Create.vue